import {
	CheckboxOption,
	UniversityMultiOptionQueryParam,
} from '@uc/web/shared/data-models';
import {
	UniversitiesFilterOptions,
	UniversityFilterPill,
	UniversitySearchPayload,
} from '../models/university-search.models';

export const generatePills = (
	payload: UniversitySearchPayload,
	filters: UniversitiesFilterOptions,
): UniversityFilterPill[] => {
	return [...generateFilterPill(payload.locationIds, filters.locations, 'loc')];
};

const generateFilterPill = (
	selectedFilterIds: number[] | null,
	filters: CheckboxOption[],
	urlKey: UniversityMultiOptionQueryParam,
): UniversityFilterPill[] => {
	const selectedFilters = filters.filter((filter) =>
		selectedFilterIds?.includes(filter.id),
	);
	return selectedFilters.map((filter) => {
		const label = filter.name ? filter.name : '';
		return {
			label,
			urlKey,
			urlValue: filter.url_name,
		};
	});
};
